module.exports = require("./ff-Adlm-CM.d.ts");